import { defineComponent as _defineComponent } from 'vue'
import { Spacing } from '../../../../helpers/shared-props';
import {
  AbSection,
  AbContainer,
  AbTitle,
  AbDescription,
  AbButton,
} from '../../../ui';
import { computed } from 'vue-demi';
import HtmlRenderer from '../../../ui/HtmlRenderer.vue';

interface ButtonProp {
  text?: string | null;
  link?: string | null;
}

interface Props {
  id?: string | null;
  title?: string | null;
  subtitle?: string | null;
  description?: string | null;
  buttons?: ButtonProp[] | null;
  spacing?: Spacing | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureSectionTitleTextWithDescription',
  props: {
    id: null,
    title: null,
    subtitle: null,
    description: null,
    buttons: null,
    spacing: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string | null;
  title?: string | null;
  subtitle?: string | null;
  description?: string | null;
  buttons?: ButtonProp[] | null;
  spacing?: Spacing | null;
};



const isFirstButtonShowed = computed(
  () => props.buttons?.length && props.buttons[0],
);

const isSecondButtonShowed = computed(
  () => props.buttons?.length && props.buttons[1],
);

return { __sfc: true,props, isFirstButtonShowed, isSecondButtonShowed, AbSection, AbContainer, AbTitle, AbDescription, AbButton, HtmlRenderer }
}

})